import {
    AutoLabelRecommendedChangeSensitivityInfoBarMessage,
    ClearRecommendedInfobarMessage,
} from './getChangeLabelLink.locstring.json';
import loc from 'owa-localize';
import CLPViewState, { LabelApplyMethod } from '../../store/schema/clp/CLPViewState';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import {
    InfoBarCustomAction,
    InfoBarHostViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import internalSetSelectedCLPLabel from '../../actions/clp/internalSetSelectedCLPLabel';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import { logRecommendedLabelApplied, logRecommendedLabelDismissed } from './logCLPDatapoints';
import constructCLPAuditAction from './constructCLPAuditAction';
import addAuditActionToViewState from '../../actions/clp/addAuditActionToViewState';
import {
    CLPAuditLogType,
    CLPAuditOperation,
    CLPAuditOperationTrigger,
    CLPAuditSensitivityChange,
} from '../../store/schema/clp/CLPAuditAction';

export function getChangeLabelLink(
    infobarViewState: InfoBarHostViewState,
    clpViewState: CLPViewState,
    recommendedLabel: CLPLabel
): InfoBarCustomAction {
    return {
        text: loc(AutoLabelRecommendedChangeSensitivityInfoBarMessage),
        action: () => {
            addAuditActionToViewState(
                clpViewState,
                constructCLPAuditAction(
                    recommendedLabel,
                    CLPAuditLogType.LabelAction,
                    CLPAuditOperation.LabelApplied,
                    CLPAuditOperationTrigger.Recommended,
                    CLPAuditSensitivityChange.Upgraded,
                    clpViewState.selectedCLPLabel
                )
            );
            logRecommendedLabelApplied();
            // Choose to apply recommended label is considered as a manual opperation.
            internalSetSelectedCLPLabel(clpViewState, recommendedLabel, LabelApplyMethod.Manual);
            removeInfoBarMessage(infobarViewState, 'CLPAutoLabelAutomatic');
            removeInfoBarMessage(infobarViewState, 'CLPAutoLabelRecommended');
            addInfoBarMessage(infobarViewState, 'CLPLabel');
        },
    };
}

export function getClearInfobarIcon(infobarViewState: InfoBarHostViewState): InfoBarCustomAction {
    return {
        text: loc(ClearRecommendedInfobarMessage),
        action: () => {
            logRecommendedLabelDismissed();
            removeInfoBarMessage(infobarViewState, 'CLPAutoLabelRecommended');
        },
    };
}
